import { paytmConstants } from '../Constants';
import { paytmService } from '../Services';

export const paytmActions = {
    getLoanDetails,
    postInitialOrder,
    validatePaymentLink,
    paytmdefaultState
}

function paytmdefaultState() {
    return dispatch => {
        dispatch({ type: paytmConstants.PAYTM_ERROR_CLEAR_ALL });
    };
}

function getLoanDetails(ID, TOKEN) {
    return dispatch => {
        dispatch(request());

        paytmService.getLoanDetails(ID, TOKEN)
            .then(
                loan => dispatch(success(loan)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: paytmConstants.GET_LOAN_DETAILS_REQUEST } }
    function success(loan) { return { type: paytmConstants.GET_LOAN_DETAILS_SUCCESS, loan } }
    function failure(error) { return { type: paytmConstants.GET_LOAN_DETAILS_FAILURE, error } }
}

function postInitialOrder(initialOrder, TOKEN) {
    return dispatch => {
        dispatch(request());

        paytmService.postInitialOrder(initialOrder, TOKEN)
            .then(
                initialOrder => dispatch(success(initialOrder)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: paytmConstants.POST_INITIAL_ORDER_REQUEST } }
    function success(initialOrder) { return { type: paytmConstants.POST_INITIAL_ORDER_SUCCESS, initialOrder } }
    function failure(error) { return { type: paytmConstants.POST_INITIAL_ORDER_FAILURE, error } }
}

function validatePaymentLink(paymentInfo, TOKEN) {
    return dispatch => {
        dispatch(request());

        paytmService.validatePaymentLink(paymentInfo, TOKEN)
            .then(
                paymentInfo => dispatch(success(paymentInfo)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: paytmConstants.VALIDATE_PAYMENT_LINK_REQUEST } }
    function success(paymentInfo) { return { type: paytmConstants.VALIDATE_PAYMENT_LINK_SUCCESS, paymentInfo } }
    function failure(error) { return { type: paytmConstants.VALIDATE_PAYMENT_LINK_FAILURE, error } }
}